export default __webpack_public_path__ + "static/media/minus.f03c9223.svg";